<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import store from '@/store';
import axios from '@/plugins/axios';

export default {
  name: 'App',

  components: {},

  data: () => ({
    //
  }),
  created() {
    axios.interceptors.response.use(null, (error) => {
      if (error.response && error.response.status === 401) {
        store.dispatch('auth/logOut');
        if (this.$router.currentRoute.name !== 'login') {
          this.$router.push({ name: 'login' });
        }
      }
      error.isAxiosError = true; /* eslint-disable-line  */
      return Promise.reject(error);
    });
  },
};
</script>
<style lang="scss">
@import '~@/assets/styles/index';
</style>
